module.exports = "<fuse-main></fuse-main>\r\n"


//////////////////
// WEBPACK FOOTER
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main